import React, { useMemo } from 'react'
import { formatPersonName } from '../../../utils/personUtils'
import { PersonLiteDto, PersonDto } from '../../../api/person/models/PersonDto'
import { RecommendedCandidateWithRecsDto } from '../../../api/role/models/getRecommendedCandidatesForRole/GetRecommendedCandidatesForRole'
import RecommendedCandidateCard from './RecommendedCandidateCard'
// New imports for types
import { TransformedResolvedPerson } from '../../../utils/networkTransformUtils'
import { CompanyDto } from '../../../api/company/models/CompanyDto'
import { MapExtra } from '../../../utils/MapExtra'

export default function RecommendedCandidatesList({
    candidates,
    personById,
    connectionsByPersonId,
    companiesById,
    personFullById,
}: {
    candidates: RecommendedCandidateWithRecsDto[]
    personById: MapExtra<string, PersonLiteDto>
    connectionsByPersonId: Map<string, TransformedResolvedPerson>
    companiesById: MapExtra<string, CompanyDto>
    personFullById: MapExtra<string, PersonDto>
}): React.JSX.Element {
    const sorted = useMemo(() => {
        // Sort by number of recommendations desc, then by name
        return [...candidates].sort((a, b) => {
            const diff = b.recommendations.length - a.recommendations.length
            if (diff !== 0) return diff
            const an = formatPersonName(a.candidate).toLowerCase()
            const bn = formatPersonName(b.candidate).toLowerCase()
            return an.localeCompare(bn, undefined, { sensitivity: 'base' })
        })
    }, [candidates])

    if (sorted.length === 0) {
        return (
            <div className="p-6 border rounded-xl bg-white text-center text-gray-500">
                No recommendations yet.
            </div>
        )
    }

    return (
        <div className="flex flex-col gap-2 w-full mt-2">
            {sorted.map((item) => (
                <RecommendedCandidateCard
                    key={item.candidate.id}
                    candidate={item.candidate}
                    recommendations={item.recommendations}
                    personById={personById}
                    // New props for connections view
                    connections={connectionsByPersonId.get(item.candidate.id)}
                    companiesById={companiesById}
                    personFull={personFullById.get(item.candidate.id)}
                />
            ))}
        </div>
    )
}
